/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramWhiteLabelsControllerFindOneByCountryQueryResponse,
  TelegramWhiteLabelsControllerFindOneByCountryPathParams,
  TelegramWhiteLabelsControllerFindOneByCountry404,
} from '../../types/TelegramWhiteLabelsControllerFindOneByCountry.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramWhiteLabelsFindOneByCountry } from '../../methods/telegramWhiteLabelsFindOneByCountry.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramWhiteLabelsFindOneByCountryQueryKey = (
  countryCode: TelegramWhiteLabelsControllerFindOneByCountryPathParams['countryCode'],
) => [{ url: '/api/telegram/white-labels/country/:countryCode', params: { countryCode: countryCode } }] as const;

export type TelegramWhiteLabelsFindOneByCountryQueryKey = ReturnType<
  typeof telegramWhiteLabelsFindOneByCountryQueryKey
>;

export function telegramWhiteLabelsFindOneByCountryQueryOptions(
  countryCode: TelegramWhiteLabelsControllerFindOneByCountryPathParams['countryCode'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramWhiteLabelsFindOneByCountryQueryKey(countryCode);
  return queryOptions<
    TelegramWhiteLabelsControllerFindOneByCountryQueryResponse,
    ResponseErrorConfig<TelegramWhiteLabelsControllerFindOneByCountry404>,
    TelegramWhiteLabelsControllerFindOneByCountryQueryResponse,
    typeof queryKey
  >({
    enabled: !!countryCode,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramWhiteLabelsFindOneByCountry(countryCode, config);
    },
  });
}

/**
 * {@link /api/telegram/white-labels/country/:countryCode}
 */
export function useTelegramWhiteLabelsFindOneByCountry<
  TData = TelegramWhiteLabelsControllerFindOneByCountryQueryResponse,
  TQueryData = TelegramWhiteLabelsControllerFindOneByCountryQueryResponse,
  TQueryKey extends QueryKey = TelegramWhiteLabelsFindOneByCountryQueryKey,
>(
  countryCode: TelegramWhiteLabelsControllerFindOneByCountryPathParams['countryCode'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramWhiteLabelsControllerFindOneByCountryQueryResponse,
        ResponseErrorConfig<TelegramWhiteLabelsControllerFindOneByCountry404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramWhiteLabelsFindOneByCountryQueryKey(countryCode);

  const query = useQuery(
    {
      ...telegramWhiteLabelsFindOneByCountryQueryOptions(countryCode, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramWhiteLabelsControllerFindOneByCountry404>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
